var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "panel wrap_panel shadow-0 border-0",
      attrs: { id: "panel_exchange_user_list" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container" }, [
        _c("div", { staticClass: "panel-content" }, [
          _c("div", { staticClass: "row-fluid" }, [
            _c("div", { staticClass: "user_list_exchange" }, [
              _vm.users.length === 0
                ? _c("div", [
                    _c("div", { staticClass: "empty_block" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\tКористувачiв не знайдено\n\t\t\t\t\t\t"
                      ),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "exist_user" },
                    [
                      _c(
                        "b-overlay",
                        { attrs: { show: _vm.is_load } },
                        [
                          _c("f_users_table", {
                            attrs: {
                              user_id: parseInt(this.user.id),
                              users: _vm.users,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("f_users_edit", { attrs: { user_id: parseInt(this.user.id) } }),
      _vm._v(" "),
      _c("div", { staticClass: "add_block" }, [
        _c("div", { staticClass: "buttons" }, [
          _c("div", { staticClass: "next_step" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-lg btn-outline-primary waves-effect waves-themed add_exchange_user",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.edit_user(null)
                  },
                },
              },
              [
                _c("span", { staticClass: "fal fa-check mr-1" }),
                _vm._v("\n\t\t\t\t\tДодати\n\t\t\t\t"),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-hdr text-danger" }, [
      _c("h2", [
        _c("span", { staticClass: "fw-300" }, [
          _c("i", [_vm._v("Користувачi")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }